import { gql } from 'urql';

export const LocationDetails = gql`
  fragment LocationDetails on Location {
    id
    name
    streetAddress
    city
    region
    zipCode
  }
`;
